export const GET = 'GET';
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';

export const CONTENT_TYPE_JSON = 'application/json';

export const httpJsonRequest = function (method, url, data, success, contentType) {
    contentType = contentType || CONTENT_TYPE_JSON;
    if (method !== GET && contentType === CONTENT_TYPE_JSON) {
        data = JSON.stringify(data);
    }
    return jQuery.ajax({
        url: url,
        data: data,
        method: method,
        contentType: contentType,
        success: success,
    });
};

export const httpGet = function (url, success, contentType) {
    return httpJsonRequest(GET, url, [], success, contentType);
};

export const httpPost = function (url, data, success, contentType) {
    return httpJsonRequest(POST, url, data, success, contentType);
};

export const httpPut = function (url, data, success, contentType) {
    return httpJsonRequest(PUT, url, data, success, contentType);
};

export const httpDelete = function (url, data, success, contentType) {
    return httpJsonRequest(DELETE, url, data, success, contentType);
};

export const httpPostFormData = (url, formData, options = {}) => {
    return jQuery.ajax({
        url: url,
        method: POST,
        data: formData,
        processData: false,
        contentType: false,
        ...options,
    });
};
